<template>
    <div
        class="universe-card gcmcn-card"
        :class="{'active': isSelectedUniverse}"
        @click="selectUniverse"
    >
        <div class="data">
            <div class="card-title">{{ universe.display_name }}</div>
        </div>

        <i
            class="el-icon-arrow-right selection-arrow"
            :class="{'rotate-icon-arrow' : isSelectedUniverse}"
        ></i>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        universe: {
            type: Object,
            required: true
        },
        selectedUniverse: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        },
    },

    data: function(){
        return {
        };
    },

    computed: {
        isSelectedUniverse (){
            return this.selectedUniverse !== null && this.selectedUniverse.uid === this.universe.uid;
        }
    },


    methods: {
        selectUniverse() {
            this.$emit('on-universe-selected', this.universe.uid);
        },
    },
};
</script>

<style lang="scss">
.universe-card {
    position: relative;
    &.active {
        background-color: #333;
    }
    .card-title {
        color: #EEE;
    }
    +.universe-card {
        margin-top: 10px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/page/Universes/universeCard.vue